// // import React, { useState } from 'react';
// // import { useForm } from 'react-hook-form';
// // import { FaTimes, FaUpload } from 'react-icons/fa';
// // import axios from 'axios';
// // import { toast } from 'react-toastify';
// // import Modal from 'react-modal';

// // // Bind modal to your appElement for accessibility
// // Modal.setAppElement('#root');

// // const ApplyModal = ({ isOpen, onClose, job }) => {
// //   const [loading, setLoading] = useState(false);
// //   const [resumeFile, setResumeFile] = useState(null);
  
// //   const { register, handleSubmit, formState: { errors }, reset } = useForm();

// //   const onSubmit = async (data) => {
// //     try {
// //       setLoading(true);
      
// //       const formData = new FormData();
// //       Object.keys(data).forEach(key => {
// //         formData.append(key, data[key]);
// //       });
// //       if (resumeFile) {
// //         formData.append('resume', resumeFile);
// //       }

// //       const response = await axios.post(
// //         `${process.env.REACT_APP_API_URL}/api/jobs/${job._id}/apply`,
// //         formData,
// //         {
// //           headers: {
// //             'Content-Type': 'multipart/form-data'
// //           }
// //         }
// //       );

// //       if (response.data.success) {
// //         toast.success('Application submitted successfully!');
// //         reset();
// //         setResumeFile(null);
// //         onClose();
// //       }
// //     } catch (error) {
// //       toast.error(error.response?.data?.message || 'Failed to submit application');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   return (
// //     <Modal
// //       isOpen={isOpen}
// //       onRequestClose={onClose}
// //       className="max-w-2xl mx-auto mt-20 bg-white rounded-lg shadow-xl outline-none"
// //       overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center p-4 z-50"
// //     >
// //       <div className="relative">
// //         {/* Close button */}
// //         <button
// //           onClick={onClose}
// //           className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition duration-300"
// //         >
// //           <FaTimes className="text-xl" />
// //         </button>

// //         {/* Header */}
// //         <div className="bg-gradient-to-r from-blue-900 to-blue-700 text-white p-6 rounded-t-lg">
// //           <h2 className="text-2xl font-bold">Apply for {job?.title}</h2>
// //           <p className="text-blue-100 mt-2">Please fill in your details below</p>
// //         </div>

// //         {/* Form */}
// //         <form onSubmit={handleSubmit(onSubmit)} className="p-6">
// //           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
// //             {/* First Name */}
// //             <div>
// //               <label className="block text-sm font-medium text-gray-700 mb-2">
// //                 First Name *
// //               </label>
// //               <input
// //                 type="text"
// //                 {...register('firstName', { required: 'First name is required' })}
// //                 className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
// //               />
// //               {errors.firstName && (
// //                 <p className="mt-1 text-sm text-red-600">{errors.firstName.message}</p>
// //               )}
// //             </div>

// //             {/* Last Name */}
// //             <div>
// //               <label className="block text-sm font-medium text-gray-700 mb-2">
// //                 Last Name *
// //               </label>
// //               <input
// //                 type="text"
// //                 {...register('lastName', { required: 'Last name is required' })}
// //                 className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
// //               />
// //               {errors.lastName && (
// //                 <p className="mt-1 text-sm text-red-600">{errors.lastName.message}</p>
// //               )}
// //             </div>

// //             {/* Email */}
// //             <div>
// //               <label className="block text-sm font-medium text-gray-700 mb-2">
// //                 Email *
// //               </label>
// //               <input
// //                 type="email"
// //                 {...register('email', { 
// //                   required: 'Email is required',
// //                   pattern: {
// //                     value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
// //                     message: 'Invalid email address'
// //                   }
// //                 })}
// //                 className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
// //               />
// //               {errors.email && (
// //                 <p className="mt-1 text-sm text-red-600">{errors.email.message}</p>
// //               )}
// //             </div>

// //             {/* Phone */}
// //             <div>
// //               <label className="block text-sm font-medium text-gray-700 mb-2">
// //                 Phone
// //               </label>
// //               <input
// //                 type="tel"
// //                 {...register('phone')}
// //                 className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
// //               />
// //             </div>

// //             {/* Current Company */}
// //             <div>
// //               <label className="block text-sm font-medium text-gray-700 mb-2">
// //                 Current Company
// //               </label>
// //               <input
// //                 type="text"
// //                 {...register('currentCompany')}
// //                 className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
// //               />
// //             </div>

// //             {/* Current Position */}
// //             <div>
// //               <label className="block text-sm font-medium text-gray-700 mb-2">
// //                 Current Position
// //               </label>
// //               <input
// //                 type="text"
// //                 {...register('currentPosition')}
// //                 className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
// //               />
// //             </div>

// //             {/* Experience */}
// //             <div>
// //               <label className="block text-sm font-medium text-gray-700 mb-2">
// //                 Years of Experience
// //               </label>
// //               <input
// //                 type="number"
// //                 {...register('experience', { min: 0 })}
// //                 className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
// //               />
// //             </div>

// //             {/* Expected Salary */}
// //             <div>
// //               <label className="block text-sm font-medium text-gray-700 mb-2">
// //                 Expected Salary (USD)
// //               </label>
// //               <input
// //                 type="number"
// //                 {...register('expectedSalary', { min: 0 })}
// //                 className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
// //               />
// //             </div>

// //             {/* Notice Period */}
// //             <div>
// //               <label className="block text-sm font-medium text-gray-700 mb-2">
// //                 Notice Period (days)
// //               </label>
// //               <input
// //                 type="number"
// //                 {...register('noticePeriod', { min: 0 })}
// //                 className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
// //               />
// //             </div>

// //             {/* Portfolio */}
// //             <div className="md:col-span-2">
// //               <label className="block text-sm font-medium text-gray-700 mb-2">
// //                 Portfolio URL
// //               </label>
// //               <input
// //                 type="url"
// //                 {...register('portfolio')}
// //                 className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
// //                 placeholder="https://..."
// //               />
// //             </div>

// //             {/* LinkedIn */}
// //             <div className="md:col-span-2">
// //               <label className="block text-sm font-medium text-gray-700 mb-2">
// //                 LinkedIn Profile
// //               </label>
// //               <input
// //                 type="url"
// //                 {...register('linkedin')}
// //                 className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
// //                 placeholder="https://linkedin.com/in/..."
// //               />
// //             </div>

// //             {/* Resume Upload */}
// //             <div className="md:col-span-2">
// //               <label className="block text-sm font-medium text-gray-700 mb-2">
// //                 Resume *
// //               </label>
// //               <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center">
// //                 <input
// //                   type="file"
// //                   accept=".pdf,.doc,.docx"
// //                   onChange={(e) => setResumeFile(e.target.files[0])}
// //                   className="hidden"
// //                   id="resume-upload"
// //                   required
// //                 />
// //                 <label
// //                   htmlFor="resume-upload"
// //                   className="cursor-pointer flex flex-col items-center"
// //                 >
// //                   <FaUpload className="text-3xl text-gray-400 mb-2" />
// //                   <span className="text-sm text-gray-600">
// //                     {resumeFile ? resumeFile.name : 'Click to upload or drag and drop'}
// //                   </span>
// //                   <span className="text-xs text-gray-500 mt-1">
// //                     PDF, DOC, DOCX (Max 5MB)
// //                   </span>
// //                 </label>
// //               </div>
// //             </div>

// //             {/* Cover Letter */}
// //             <div className="md:col-span-2">
// //               <label className="block text-sm font-medium text-gray-700 mb-2">
// //                 Cover Letter
// //               </label>
// //               <textarea
// //                 {...register('coverLetter')}
// //                 rows="4"
// //                 className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
// //                 placeholder="Tell us why you're interested in this position..."
// //               ></textarea>
// //             </div>
// //           </div>

// //           {/* Submit Button */}
// //           <div className="mt-6">
// //             <button
// //               type="submit"
// //               disabled={loading}
// //               className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition duration-300 disabled:bg-blue-400"
// //             >
// //               {loading ? 'Submitting...' : 'Submit Application'}
// //             </button>
// //           </div>
// //         </form>
// //       </div>
// //     </Modal>
// //   );
// // };

// // export default ApplyModal;











// import React, { useState, useCallback } from 'react';
// import { useForm } from 'react-hook-form';
// import { FaTimes, FaUpload, FaSpinner } from 'react-icons/fa';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import Modal from 'react-modal';

// // Bind modal to your appElement for accessibility
// Modal.setAppElement('#root');

// const ApplyModal = ({ isOpen, onClose, job }) => {
//   const [loading, setLoading] = useState(false);
//   const [resumeFile, setResumeFile] = useState(null);
//   const [dragActive, setDragActive] = useState(false);

//   const {
//     register,
//     handleSubmit,
//     reset,
//     formState: { errors }
//   } = useForm();

//   // Handle drag events for file upload
//   const handleDrag = useCallback((e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     if (e.type === 'dragenter' || e.type === 'dragover') {
//       setDragActive(true);
//     } else if (e.type === 'dragleave') {
//       setDragActive(false);
//     }
//   }, []);

//   const handleDrop = useCallback((e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setDragActive(false);
//     if (e.dataTransfer.files && e.dataTransfer.files[0]) {
//       setResumeFile(e.dataTransfer.files[0]);
//     }
//   }, []);

//   const onSubmit = async (data) => {
//     try {
//       setLoading(true);

//       const formData = new FormData();
//       Object.keys(data).forEach((key) => {
//         formData.append(key, data[key]);
//       });
//       if (resumeFile) {
//         formData.append('resume', resumeFile);
//       }

//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/api/jobs/${job._id}/apply`,
//         formData,
//         {
//           headers: {
//             'Content-Type': 'multipart/form-data'
//           }
//         }
//       );

//       if (response.data.success) {
//         toast.success('Application submitted successfully!');
//         reset();
//         setResumeFile(null);
//         onClose();
//       }
//     } catch (error) {
//       toast.error(error.response?.data?.message || 'Failed to submit application');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Modal
//       isOpen={isOpen}
//       onRequestClose={onClose}
//       className="relative w-full max-w-3xl mx-auto my-8 bg-white rounded-xl shadow-2xl outline-none"
//       overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center p-4 z-50 overflow-y-auto"
//       contentLabel="Apply for Job"
//     >
//       {/* Close button */}
//       <button
//         onClick={onClose}
//         className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors z-10"
//         aria-label="Close modal"
//       >
//         <FaTimes className="text-xl" />
//       </button>

//       {/* Header */}
//       <div className="bg-gradient-to-r from-primary-600 to-primary-800 text-white p-6 rounded-t-xl">
//         <h2 className="text-2xl font-bold">Apply for {job?.title}</h2>
//         <p className="text-primary-100 mt-1">Please fill in your details below</p>
//       </div>

//       {/* Form */}
//       <form onSubmit={handleSubmit(onSubmit)} className="p-6 space-y-6">
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//           {/* First Name */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               First Name <span className="text-red-500">*</span>
//             </label>
//             <input
//               type="text"
//               {...register('firstName', { required: 'First name is required' })}
//               className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 ${
//                 errors.firstName ? 'border-red-500' : 'border-gray-300'
//               }`}
//               placeholder="John"
//             />
//             {errors.firstName && (
//               <p className="mt-1 text-sm text-red-600">{errors.firstName.message}</p>
//             )}
//           </div>

//           {/* Last Name */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Last Name <span className="text-red-500">*</span>
//             </label>
//             <input
//               type="text"
//               {...register('lastName', { required: 'Last name is required' })}
//               className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 ${
//                 errors.lastName ? 'border-red-500' : 'border-gray-300'
//               }`}
//               placeholder="Doe"
//             />
//             {errors.lastName && (
//               <p className="mt-1 text-sm text-red-600">{errors.lastName.message}</p>
//             )}
//           </div>

//           {/* Email */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Email <span className="text-red-500">*</span>
//             </label>
//             <input
//               type="email"
//               {...register('email', {
//                 required: 'Email is required',
//                 pattern: {
//                   value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
//                   message: 'Invalid email address'
//                 }
//               })}
//               className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 ${
//                 errors.email ? 'border-red-500' : 'border-gray-300'
//               }`}
//               placeholder="john@example.com"
//             />
//             {errors.email && (
//               <p className="mt-1 text-sm text-red-600">{errors.email.message}</p>
//             )}
//           </div>

//           {/* Phone */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
//             <input
//               type="tel"
//               {...register('phone', {
//                 pattern: {
//                   value: /^[+]?[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/,
//                   message: 'Invalid phone number'
//                 }
//               })}
//               className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 ${
//                 errors.phone ? 'border-red-500' : 'border-gray-300'
//               }`}
//               placeholder="+1 (123) 456-7890"
//             />
//             {errors.phone && (
//               <p className="mt-1 text-sm text-red-600">{errors.phone.message}</p>
//             )}
//           </div>

//           {/* Current Company */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">Current Company</label>
//             <input
//               type="text"
//               {...register('currentCompany')}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
//               placeholder="Acme Inc."
//             />
//           </div>

//           {/* Current Position */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">Current Position</label>
//             <input
//               type="text"
//               {...register('currentPosition')}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
//               placeholder="Software Developer"
//             />
//           </div>

//           {/* Experience */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">Years of Experience</label>
//             <input
//               type="number"
//               {...register('experience', { min: 0, max: 50 })}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
//               placeholder="5"
//             />
//           </div>

//           {/* Expected Salary */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">Expected Salary (USD)</label>
//             <input
//               type="number"
//               {...register('expectedSalary', { min: 0 })}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
//               placeholder="80000"
//             />
//           </div>

//           {/* Notice Period */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">Notice Period (days)</label>
//             <input
//               type="number"
//               {...register('noticePeriod', { min: 0 })}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
//               placeholder="30"
//             />
//           </div>

//           {/* Portfolio URL */}
//           <div className="sm:col-span-2">
//             <label className="block text-sm font-medium text-gray-700 mb-1">Portfolio URL</label>
//             <input
//               type="url"
//               {...register('portfolio')}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
//               placeholder="https://yourportfolio.com"
//             />
//           </div>

//           {/* LinkedIn Profile */}
//           <div className="sm:col-span-2">
//             <label className="block text-sm font-medium text-gray-700 mb-1">LinkedIn Profile</label>
//             <input
//               type="url"
//               {...register('linkedin')}
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
//               placeholder="https://linkedin.com/in/yourprofile"
//             />
//           </div>

//           {/* Resume Upload */}
//           <div className="sm:col-span-2">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Resume <span className="text-red-500">*</span>
//             </label>
//             <div
//               onDragEnter={handleDrag}
//               onDragLeave={handleDrag}
//               onDragOver={handleDrag}
//               onDrop={handleDrop}
//               className={`relative border-2 border-dashed rounded-lg p-6 transition-colors ${
//                 dragActive
//                   ? 'border-primary-500 bg-primary-50'
//                   : resumeFile
//                   ? 'border-green-500 bg-green-50'
//                   : 'border-gray-300 hover:border-primary-400'
//               }`}
//             >
//               <input
//                 type="file"
//                 accept=".pdf,.doc,.docx"
//                 onChange={(e) => setResumeFile(e.target.files[0])}
//                 className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
//                 id="resume-upload"
//                 required={!resumeFile}
//               />
//               <div className="text-center pointer-events-none">
//                 <FaUpload
//                   className={`mx-auto text-3xl mb-2 ${
//                     dragActive
//                       ? 'text-primary-500'
//                       : resumeFile
//                       ? 'text-green-500'
//                       : 'text-gray-400'
//                   }`}
//                 />
//                 {resumeFile ? (
//                   <div>
//                     <p className="text-sm font-medium text-gray-700">{resumeFile.name}</p>
//                     <p className="text-xs text-gray-500 mt-1">
//                       {(resumeFile.size / 1024).toFixed(2)} KB
//                     </p>
//                   </div>
//                 ) : (
//                   <>
//                     <p className="text-sm text-gray-600">
//                       <span className="font-semibold text-primary-600">Click to upload</span> or drag and drop
//                     </p>
//                     <p className="text-xs text-gray-500 mt-1">PDF, DOC, DOCX (Max 5MB)</p>
//                   </>
//                 )}
//               </div>
//             </div>
//             {!resumeFile && (
//               <p className="mt-1 text-sm text-red-600">Resume is required</p>
//             )}
//           </div>

//           {/* Cover Letter */}
//           <div className="sm:col-span-2">
//             <label className="block text-sm font-medium text-gray-700 mb-1">Cover Letter</label>
//             <textarea
//               {...register('coverLetter')}
//               rows="4"
//               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
//               placeholder="Tell us why you're interested in this position..."
//             ></textarea>
//           </div>
//         </div>

//         {/* Submit Button */}
//         <button
//           type="submit"
//           disabled={loading || !resumeFile}
//           className="w-full bg-primary-600 text-white py-3 rounded-lg font-semibold hover:bg-primary-700 transition duration-300 disabled:bg-primary-300 disabled:cursor-not-allowed flex items-center justify-center gap-2"
//         >
//           {loading && <FaSpinner className="animate-spin" />}
//           {loading ? 'Submitting...' : 'Submit Application'}
//         </button>
//       </form>
//     </Modal>
//   );
// };

// export default ApplyModal;










import React, { useState, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { FaTimes, FaUpload, FaSpinner } from 'react-icons/fa';
import axios from 'axios';
import { toast } from 'react-toastify';
import Modal from 'react-modal';

Modal.setAppElement('#root');

const ApplyModal = ({ isOpen, onClose, job }) => {
  const [loading, setLoading] = useState(false);
  const [resumeFile, setResumeFile] = useState(null);
  const [dragActive, setDragActive] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm();

  const handleDrag = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setResumeFile(e.dataTransfer.files[0]);
    }
  }, []);

  const onSubmit = async (data) => {
    try {
      setLoading(true);

      const formData = new FormData();

      // Helper to trim strings and append if not empty
      const appendIfPresent = (key, value) => {
        if (value !== undefined && value !== null && value !== '') {
          // Trim strings to remove extra spaces
          const trimmed = typeof value === 'string' ? value.trim() : value;
          formData.append(key, trimmed);
        }
      };

      // Append required fields
      appendIfPresent('firstName', data.firstName);
      appendIfPresent('lastName', data.lastName);
      appendIfPresent('email', data.email);

      // Optional fields
      appendIfPresent('phone', data.phone);
      appendIfPresent('currentCompany', data.currentCompany);
      appendIfPresent('currentPosition', data.currentPosition);
      appendIfPresent('portfolio', data.portfolio);
      appendIfPresent('linkedin', data.linkedin);
      appendIfPresent('coverLetter', data.coverLetter);

      // Numeric fields: ensure they are valid numbers and not empty
      if (data.experience && data.experience.toString().trim() !== '') {
        const num = parseInt(data.experience, 10);
        if (!isNaN(num)) {
          formData.append('experience', num);
        }
      }
      if (data.expectedSalary && data.expectedSalary.toString().trim() !== '') {
        const num = parseInt(data.expectedSalary, 10);
        if (!isNaN(num)) {
          formData.append('expectedSalary', num);
        }
      }
      if (data.noticePeriod && data.noticePeriod.toString().trim() !== '') {
        const num = parseInt(data.noticePeriod, 10);
        if (!isNaN(num)) {
          formData.append('noticePeriod', num);
        }
      }

      // Resume file (required)
      if (resumeFile) {
        formData.append('resume', resumeFile);
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/jobs/${job._id}/apply`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      if (response.data.success) {
        toast.success('Application submitted successfully!');
        reset();
        setResumeFile(null);
        onClose();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to submit application');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="relative w-full max-w-3xl mx-auto my-8 bg-white rounded-xl shadow-2xl outline-none"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center p-4 z-50 overflow-y-auto"
      contentLabel="Apply for Job"
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors z-10"
        aria-label="Close modal"
      >
        <FaTimes className="text-xl" />
      </button>

      <div className="bg-gradient-to-r from-primary-600 to-primary-800 text-white p-6 rounded-t-xl">
        <h2 className="text-2xl font-bold">Apply for {job?.title}</h2>
        <p className="text-primary-100 mt-1">Please fill in your details below</p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="p-6 space-y-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {/* First Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              First Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              {...register('firstName', { required: 'First name is required' })}
              className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 ${
                errors.firstName ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="John"
            />
            {errors.firstName && (
              <p className="mt-1 text-sm text-red-600">{errors.firstName.message}</p>
            )}
          </div>

          {/* Last Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Last Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              {...register('lastName', { required: 'Last name is required' })}
              className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 ${
                errors.lastName ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="Doe"
            />
            {errors.lastName && (
              <p className="mt-1 text-sm text-red-600">{errors.lastName.message}</p>
            )}
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              {...register('email', {
                required: 'Email is required',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'Invalid email address'
                }
              })}
              className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 ${
                errors.email ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="john@example.com"
            />
            {errors.email && (
              <p className="mt-1 text-sm text-red-600">{errors.email.message}</p>
            )}
          </div>

          {/* Phone */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
            <input
              type="tel"
              {...register('phone', {
                pattern: {
                  value: /^[+]?[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/,
                  message: 'Invalid phone number'
                }
              })}
              className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 ${
                errors.phone ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="+1 (123) 456-7890"
            />
            {errors.phone && (
              <p className="mt-1 text-sm text-red-600">{errors.phone.message}</p>
            )}
          </div>

          {/* Current Company */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Current Company</label>
            <input
              type="text"
              {...register('currentCompany')}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              placeholder="Acme Inc."
            />
          </div>

          {/* Current Position */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Current Position</label>
            <input
              type="text"
              {...register('currentPosition')}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              placeholder="Software Developer"
            />
          </div>

          {/* Experience */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Years of Experience</label>
            <input
              type="number"
              {...register('experience', { min: 0, max: 50 })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              placeholder="5"
            />
          </div>

          {/* Expected Salary */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Expected Salary (USD)</label>
            <input
              type="number"
              {...register('expectedSalary', { min: 0 })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              placeholder="80000"
            />
          </div>

          {/* Notice Period */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Notice Period (days)</label>
            <input
              type="number"
              {...register('noticePeriod', { min: 0 })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              placeholder="30"
            />
          </div>

          {/* Portfolio URL */}
          <div className="sm:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">Portfolio URL</label>
            <input
              type="url"
              {...register('portfolio')}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              placeholder="https://yourportfolio.com"
            />
          </div>

          {/* LinkedIn Profile */}
          <div className="sm:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">LinkedIn Profile</label>
            <input
              type="url"
              {...register('linkedin')}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              placeholder="https://linkedin.com/in/yourprofile"
            />
          </div>

          {/* Resume Upload */}
          <div className="sm:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Resume <span className="text-red-500">*</span>
            </label>
            <div
              onDragEnter={handleDrag}
              onDragLeave={handleDrag}
              onDragOver={handleDrag}
              onDrop={handleDrop}
              className={`relative border-2 border-dashed rounded-lg p-6 transition-colors ${
                dragActive
                  ? 'border-primary-500 bg-primary-50'
                  : resumeFile
                  ? 'border-green-500 bg-green-50'
                  : 'border-gray-300 hover:border-primary-400'
              }`}
            >
              <input
                type="file"
                accept=".pdf,.doc,.docx"
                onChange={(e) => setResumeFile(e.target.files[0])}
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                id="resume-upload"
                required={!resumeFile}
              />
              <div className="text-center pointer-events-none">
                <FaUpload
                  className={`mx-auto text-3xl mb-2 ${
                    dragActive
                      ? 'text-primary-500'
                      : resumeFile
                      ? 'text-green-500'
                      : 'text-gray-400'
                  }`}
                />
                {resumeFile ? (
                  <div>
                    <p className="text-sm font-medium text-gray-700">{resumeFile.name}</p>
                    <p className="text-xs text-gray-500 mt-1">
                      {(resumeFile.size / 1024).toFixed(2)} KB
                    </p>
                  </div>
                ) : (
                  <>
                    <p className="text-sm text-gray-600">
                      <span className="font-semibold text-primary-600">Click to upload</span> or drag and drop
                    </p>
                    <p className="text-xs text-gray-500 mt-1">PDF, DOC, DOCX (Max 5MB)</p>
                  </>
                )}
              </div>
            </div>
            {!resumeFile && (
              <p className="mt-1 text-sm text-red-600">Resume is required</p>
            )}
          </div>

          {/* Cover Letter */}
          <div className="sm:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">Cover Letter</label>
            <textarea
              {...register('coverLetter')}
              rows="4"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              placeholder="Tell us why you're interested in this position..."
            ></textarea>
          </div>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={loading || !resumeFile}
          className="w-full bg-primary-600 text-white py-3 rounded-lg font-semibold hover:bg-primary-700 transition duration-300 disabled:bg-primary-300 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          {loading && <FaSpinner className="animate-spin" />}
          {loading ? 'Submitting...' : 'Submit Application'}
        </button>
      </form>
    </Modal>
  );
};

export default ApplyModal;